import * as React from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Modal, Form, Button, Image, InputGroup, FormControl, Overlay, Tooltip } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { motion } from "framer-motion";
const nl2br = require('react-nl2br');


export const Done = () => {
    window.scrollTo(0, 0);

    const location = useLocation();
    const [ittengo, setIttengo] = React.useState(location.state.ittengo);
    const [message, setMessage] = React.useState(location.state.message);
    const [giftId, setGiftId]   = React.useState(location.state.giftId);
    const [expiredAt, setExpiredAt] = React.useState(location.state.expiredAt);
  
    const [show, setShow] = React.useState(false);
    const giftUrl = "https://gift.hsg.link/" + giftId + "/";
  
    const shareData = {
      url: giftUrl
    }
  
    const share = async () => {
      try {
        await navigator.share(shareData)
      } catch(error) {
        console.log(error)
      }
    }
  
    const target = React.useRef(null);
  
    return (
      <>
        <motion.div
          animate={{
            x: 0,
            opacity: 1
          }}
          initial={{
            x: 100,
            opacity: 0
          }}
          exit={{
            x: -100,
            opacity: 0
          }}
          transition={{
            duration: 0.2
          }}
        >
          <main>
            <h2>3. カードを贈る</h2>
  
            <Image src={ittengo.image} alt={ittengo.honkaku.title} fluid />
            <div className="mt-4">
              <Image src={ittengo.border_top} className="mb-3" fluid />
              <p>{nl2br(message)}</p>
              <Image src={ittengo.border_bottom} fluid />
            </div>


            <div className="d-md-none mt-5">
              <Button variant="primary" onClick={share} className="ms-2">カードを贈る</Button>
            </div>
            <div className="d-none d-md-block mt-5">
              <CopyToClipboard text={giftUrl} onCopy={() => setShow(true)}>
                <InputGroup className="mb-3">
                  <FormControl
                    value={giftUrl}
                    aria-describedby="basic-addon2"
                    disabled="disabled"
                  />
                  <Button ref={target} variant="outline-secondary" id="button-addon2">
                    コピー
                  </Button>
                  <Overlay target={target.current} show={show} placement="right">
                    {(props) => (
                      <Tooltip {...props}>
                        コピーしました
                      </Tooltip>
                    )}
                  </Overlay>
                </InputGroup>
              </CopyToClipboard>
              <p>このURLをメール等でお送りください。</p>
            </div>

            <div className="text-center my-5">
                ・<br />
                ・<br />
                ・<br />
            </div>

            <p><small className="text-secondary">※このカードの有効期限は {expiredAt} です。</small><br />
            <a href="https://elform.co/g/itmw/mothersday2022/" target="_blank" rel="noreferrer"><small className="text-secondary">ご意見・ご感想はこちら</small></a></p>

          </main>
        </motion.div>
      </>
    );
  }